const Loader = ({ color, className }) => {
  let c = color ? color : "text-blue-600";

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`animate-spin inline-block w-8 h-8 border-[3px] border-current border-t-transparent rounded-full ${c}`}
        role="status"
        aria-live="polite"
        aria-label="loading"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
